import React from 'react';
import { Link } from 'react-router-dom';

const ToolCard = ({ tool, showEditButton, isLoggedIn, onLoginRequired }) => {
  const handleToolClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault();
      onLoginRequired();
    }
  };

  return (
    <div className="bg-white rounded-lg hover:shadow-lg transition duration-300 ease-in-out overflow-hidden">
      <Link to={`/tool/${tool.id}`} className="block" onClick={handleToolClick}>
        <div className="relative">
          {tool.imageUrls?.length > 0 && (
            <img 
              src={tool.imageUrls[0]} 
              alt={tool.name} 
              className="w-full h-48 object-cover"
            />
          )}
        </div>
        <div className="p-4">
          <h3 className="text-xl font-semibold mb-2 text-gray-800">{tool.name}</h3>
          <p className="text-gray-600 mb-4 text-sm">
            {tool.description.length > 100 
              ? `${tool.description.slice(0, 100)}...` 
              : tool.description}
          </p>
        </div>
      </Link>
      {showEditButton && isLoggedIn && (
        <div className="px-4 pb-4">
          <Link 
            to={`/edit-tool/${tool.id}`} 
            className="inline-block bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-300 ease-in-out text-sm"
          >
            Edit Tool
          </Link>
        </div>
      )}
    </div>
  );
};

export default ToolCard;
